import React, { useState, useRef, useEffect, useCallback } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import httpClient from "../utils/httpClients";
import { formatDistanceToNow } from "date-fns";
import { rtdb } from "../FirebaseConfig/firebase";
import { ref, set, serverTimestamp, onValue } from "firebase/database";
import { useProfile } from "../../context";

function Header() {
  const navigate = useNavigate();
  const [userProfilePic, setUserProfilePic] = useState("");
  const [mobileMenu, setMobileMenu] = useState(false);
  const [notificationOpen, setNotificationOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [showNotificationDot, setShowNotificationDot] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [mobileSearchOpen, setMobileSearchOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [chatOpen, setChatOpen] = useState(false);
  const [onlineFriends, setOnlineFriends] = useState({});
  const [userTypes, setUserTypes] = useState([]);
  const [activeUserType, setActiveUserType] = useState("");
  const [userss, setUserss] = useState([]);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [activeSubscription, setActiveSubscription] = useState(null);

  const lastQuery = useRef("");
  const location = useLocation();
  const notificationRef = useRef(null);
  const searchRef = useRef(null);
  const searchInputRef = useRef(null);
  const mobileSearchRef = useRef(null);
  const mobileSearchInputRef = useRef(null);
  const profileRef = useRef(null);
  const mobileMenuRef = useRef(null);
  const chatRef = useRef(null);
  const searchTimeoutRef = useRef(null);
  const toggleRef = useRef(null);

  const { profilePic } = useProfile();

  useEffect(() => {
    if (profilePic) {
      setUserProfilePic(profilePic);
    }
  }, [profilePic]);

  let currentUser = null;
  try {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      currentUser = JSON.parse(storedUser);
    }
    if (!currentUser) {
      window.location.reload();
    }
  } catch (err) {
    window.location.reload();
  }

  const currentUserId = currentUser?.id || currentUser?._id;
  // useEffect(() => {
  //   const fetchProfile = async () => {
  //     try {
  //       const res = await httpClient.get("/user/profile/get-profile", {
  //         skipLoader: true,
  //         skipToast: true,
  //       });
  //       if (res.data && res.data.success) {
  //         const profileData = res.data.data?.userProfile || {};
  //         setUserProfilePic(profileData.profilePic || "");
  //         const userTypes = Array.isArray(profileData.userType)
  //           ? profileData.userType
  //           : [profileData.userType];
  //         localStorage.setItem("userTypes", JSON.stringify(userTypes));
  //         localStorage.setItem("user", profileData);
  //       }
  //     } catch (error) {
  //       console.log("error", error);
  //     }
  //   };
  //   // fetchProfile();
  // }, []);

  // Get user types from localStorage
  useEffect(() => {
    const savedTypes = JSON.parse(localStorage.getItem("userTypes") || "[]");
    const currentUser = localStorage.getItem("current_user");
    setUserTypes(savedTypes);
    setActiveUserType(currentUser);
    // fetchProfile();
  }, []);

  // ✅ UPDATED: Online status listener with new path
  useEffect(() => {
    if (!currentUserId) {
      console.log("No current user ID found");
      return;
    }

    const onlineStatusRef = ref(rtdb, "onlineStatus");

    console.log("Setting up online status listener...");

    const unsubscribe = onValue(
      onlineStatusRef,
      (snapshot) => {
        const data = snapshot.val() || {};
        console.log("🔥 Online Status Data from Firebase:", data);

        const onlineData = {};
        Object.entries(data).forEach(([userId, userData]) => {
          // Current user को skip करें और केवल online users लें
          if (userId !== currentUserId && userData.online === true) {
            onlineData[userId] = {
              ...userData,
              id: userId,
            };
            console.log(`✅ Added online friend: ${userData.name}`);
          }
        });

        console.log("🎯 Final Online Friends:", onlineData);
        setOnlineFriends(onlineData);
      },
      (error) => {
        console.error("❌ Online status error:", error);
      },
    );

    return () => unsubscribe();
  }, [currentUserId]);

  const handleFriendClick = (friend, id) => {
    console.log("Selected friend id:", friend);

    navigate("/chat_message", {
      state: {
        id,
        name: friend.name,
        avatar:
          friend.profilePic ||
          `${process.env.PUBLIC_URL}/assets/images/avatars/01.png`,
        online: friend.online,
      },
    });

    setChatOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (toggleRef.current && toggleRef.current.contains(event.target)) {
        return; // 🔥 ignore toggle button clicks
      }
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target)
      ) {
        setNotificationOpen(false);
      }
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setSearchOpen(false);
      }
      if (
        mobileSearchRef.current &&
        !mobileSearchRef.current.contains(event.target)
      ) {
        setMobileSearchOpen(false);
      }
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setProfileOpen(false);
      }
      if (
        mobileMenuRef.current &&
        !mobileMenuRef.current.contains(event.target)
      ) {
        setMobileMenu(false);
      }
      if (chatRef.current && !chatRef.current.contains(event.target)) {
        setChatOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleChat = () => {
    // Always close header dropdown/collapse first (mobile responsive UX)
    setMobileMenu(false);
    setNotificationOpen(false);
    setSearchOpen(false);
    setMobileSearchOpen(false);
    setProfileOpen(false);
    setChatOpen((v) => !v);
  };

  const toggleMobile = () => {
    setMobileMenu(true);
  };
  const toggleMobileCollapse = () => {
    setMobileMenu(false);
  };
  const toggleMobileSearch = () => {
    setMobileSearchOpen(!mobileSearchOpen);
  };

  const toggleProfile = () => {
    setProfileOpen(!profileOpen);
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === "k") {
        e.preventDefault();
        // Prefer desktop search on xl+, otherwise use mobile search
        const isDesktop = window.innerWidth >= 1200;
        if (isDesktop) {
          setSearchOpen(true);
          requestAnimationFrame(() => {
            searchInputRef.current?.focus();
          });
        } else {
          setMobileMenu(false);
          setMobileSearchOpen(true);
          requestAnimationFrame(() => {
            mobileSearchInputRef.current?.focus();
          });
        }
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  const isRecentNotification = (notification) => {
    const notificationTime = new Date(
      notification.createdAt || notification.time,
    );
    const fiveMinutesAgo = new Date(Date.now() - 5 * 60 * 1000);
    return notificationTime > fiveMinutesAgo;
  };

  const fetchNotifications = async () => {
    try {
      const res = await httpClient.get("/user/notification/get-all");
      if (res.data && res.data.success) {
        const notificationsData = res.data.data?.getallNotifications || [];
        setNotifications(notificationsData);

        const hasRecent = notificationsData.some(isRecentNotification);
        setShowNotificationDot(hasRecent);
      }
    } catch (err) {
      console.error("Failed to fetch notifications:", err);
    }
  };
  useEffect(() => {
    fetchNotifications();
    const interval = setInterval(fetchNotifications, 600000);
    return () => clearInterval(interval);
  }, []);

  const handleNotificationToggle = () => {
    setNotificationOpen(!notificationOpen);
    if (!notificationOpen) {
      setShowNotificationDot(false);
    }
  };

  const handleMoveToUserAccount = () => {
    const userData = "User";
    localStorage.setItem("current_user", userData);
    setProfileOpen(false);
    // window.location.href = "/";
    navigate("/", { replace: true });
  };

  const handleMoveToArtistAccount = () => {
    const userData = "Artist";
    localStorage.setItem("current_user", userData);
    setProfileOpen(false);
    // window.location.href = "/artist/dashboard";
    navigate("/artist/dashboard", { replace: true });
  };
  console.log("activeUSerType", activeUserType);
  useEffect(() => {
    const query = searchQuery.trim();

    if (query.length < 2 || query === lastQuery.current) {
      if (query.length < 2) {
        setSearchResults([]);
      }
      return;
    }

    lastQuery.current = query;
    setIsLoading(true);

    const fetchSearch = async () => {
      try {
        const res = await httpClient.get(
          `user/music/search?query=${encodeURIComponent(query)}`,
        );
        if (res.data && res.data.success) {
          setSearchResults(res.data.data || []);
          console.log("search", res.data.data);
        }
      } catch (err) {
        console.error("Search failed:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSearch();
  }, [searchQuery]);

  // const handleSearchInputChange = (e) => {
  //   const query = e.target.value;
  //   setSearchQuery(query);
  // };
  const handleSearchInputChange = (e) => {
    const query = e.target.value;

    // ✅ CHARACTER LIMIT: Maximum 20 characters
    if (query.length > 20) {
      return; // Stop processing if more than 20 characters
    }

    // ✅ WORD LIMIT: Maximum 3 words
    const words = query
      .trim()
      .split(/\s+/)
      .filter((word) => word.length > 0);
    if (words.length > 3) {
      return; // Stop processing if more than 3 words
    }

    setSearchQuery(query);
  };

  const fetchActiveSubscription = async () => {
    try {
      // setLoading(true);
      const res = await httpClient.get("/user/user-subscription/active", {
        skipLoader: true,
        skipToast: true,
      });
      if (res.data && res.data.success) {
        setActiveSubscription(res.data.data.activeSubscriptions[0].features);
      }
    } catch (error) {
      console.error("Error fetching active subscription:", error);
      setActiveSubscription(null);
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
    fetchActiveSubscription();
  }, []);
  useEffect(() => {
    document.body.style.overflow = showLogoutModal ? "hidden" : "auto";
  }, [showLogoutModal]);

  const handleLogout = async () => {
    try {
      const storedUser = JSON.parse(localStorage.getItem("user"));
      if (storedUser?.id || storedUser?._id) {
        const uid = storedUser.id || storedUser._id;

        // ✅ Update to use "onlineStatus" instead of "status"
        const userStatusRef = ref(rtdb, "onlineStatus/" + uid);

        await set(userStatusRef, {
          online: false,
          lastSeen: serverTimestamp(),
          email: storedUser.email,
          name: storedUser.name || storedUser.email.split("@")[0],
          userId: uid,
          profilePic: storedUser.profilePic || "",
          lastOnline: serverTimestamp(),
          updatedAt: Date.now(),
        });

        console.log("✅ User set offline:", uid);
      }

      // ✅ Remove only specific localStorage keys
      localStorage.removeItem("activeNavitem");
      localStorage.removeItem("userTypes");
      localStorage.removeItem("user");
      localStorage.removeItem("volumeToken");
      localStorage.removeItem("current_user");

      console.log("✅ Selected keys removed from localStorage");
      console.log("✅ Logout successful");

      navigate("/login");
    } catch (error) {
      console.error("❌ Logout error:", error);
    }
  };

  const handleNotificationClick = (notification) => {
    if (notification.type === "message") {
      navigate("/messages");
    } else if (notification.type === "post") {
      navigate(`/post/${notification.referenceId}`);
    }
    setNotificationOpen(false);
  };

  // console.log(
  //   "activeSubscription",
  //   activeSubscription.includes("chat_with_friends"),
  // );
  const fetchAccount = async () => {
    try {
      const res = await httpClient.get("/user/profile/get-profile");
      if (res.data && res.data.success) {
        const profilePic = res.data.data?.userProfile?.profilePic;
        setUserProfilePic(
          profilePic ||
            `${process.env.PUBLIC_URL}/assets/images/dashboard/userLogo.jpeg`,
        );
      }
    } catch (err) {
      console.error("Error fetching profile:", err);
    }
  };

  useEffect(() => {
    fetchAccount();
  }, []);

  // Check if user is Artist
  const isArtist = userTypes.includes("Artist");

  return (
    <div className="position-relative">
      <nav className="nav navbar navbar-expand-xl navbar-light iq-navbar">
        <div className="container-fluid navbar-inner">
          <Link
            to={activeUserType === "Artist" ? "/artist/dashboard" : "/"}
            className="navbar-brand"
          >
            <div className="logo-main">
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/logo.png`}
                className="logo-normal img-fluid"
                alt="logo"
              />
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/logo.png`}
                className="logo-normal dark-normal img-fluid"
                alt="logo-dark"
              />
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/logo-min.png`}
                className="logo-mini img-fluid"
                alt="logo-mini"
              />
            </div>
          </Link>
          <div
            className="sidebar-toggle"
            data-toggle="sidebar"
            data-active="true"
            onClick={() => {
              // Trigger sidebar toggle by dispatching a custom event
              console.log("Header sidebar toggle clicked");
              const event = new CustomEvent("toggleSidebar");
              window.dispatchEvent(event);
            }}
            style={{ cursor: "pointer" }}
          >
            <i className="icon d-flex">
              <svg className="icon-20" width={20} viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z"
                />
              </svg>
            </i>
          </div>

          {/* Hide product offcanvas for Artist */}
          {activeUserType === "User" && (
            <div className="d-flex align-items-center justify-content-between product-offcanvas">
              <div
                className="offcanvas offcanvas-end shadow-none iq-product-menu-responsive on-rtl end"
                tabIndex={-1}
                id="offcanvasBottom"
              >
                <div className="offcanvas-body">
                  <ul className="iq-nav-menu list-unstyled">
                    <li className="nav-item">
                      <Link
                        className="nav-link active"
                        aria-current="page"
                        to="/"
                      >
                        <span className="item-name">Home</span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          )}

          <div className="d-flex align-items-center">
            <button
              ref={toggleRef}
              id="navbar-toggle"
              className={`navbar-toggler ${mobileMenu ? "" : "collapsed"}`}
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded={mobileMenu ? "true" : "false"}
              aria-label="Toggle navigation"
              onClick={mobileMenu ? toggleMobileCollapse : toggleMobile}
            >
              <span className="navbar-toggler-icon">
                <span className="navbar-toggler-bar bar1 mt-1" />
                <span className="navbar-toggler-bar bar2" />
                <span className="navbar-toggler-bar bar3" />
              </span>
            </button>
          </div>
          <div
            className={`navbar-collapse collapse ${mobileMenu ? "show" : ""}`}
            id="navbarSupportedContent"
            ref={mobileMenuRef}
          >
            {/* Hide search box for Artist */}
            {activeUserType === "User" && (
              <div className="search-box d-xl-block d-none">
                <div className="dropdown" ref={searchRef}>
                  <div
                    className="search-box-drop"
                    id="search-box-drop"
                    onClick={() => setSearchOpen(true)}
                  >
                    <div className="d-flex align-items-center justify-content-between gap-2">
                      <div className="search-box-inner">
                        <button
                          type="submit"
                          className="search-box-drop-submit"
                        >
                          <svg
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                          >
                            <circle
                              cx="11.7669"
                              cy="11.7666"
                              r="8.98856"
                              stroke="currentColor"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M18.0186 18.4851L21.5426 22"
                              stroke="currentColor"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </button>
                        <input
                          ref={searchInputRef}
                          type="text"
                          placeholder="Search Here.."
                          value={searchQuery}
                          onChange={handleSearchInputChange}
                          onFocus={() => setSearchOpen(true)}
                        />
                      </div>
                      <div className="flex-shrink-0 search-box-btn">
                        <span className="btn text-capitalize">ctrl + k</span>
                      </div>
                    </div>
                  </div>
                  <ul
                    className={`p-0 sub-drop dropdown-menu dropdown-menu-end ${
                      searchOpen ? "show" : ""
                    }`}
                    aria-labelledby="search-drop"
                  >
                    <li>
                      <div className="p-0 card-body all-notification">
                        {isLoading ? (
                          <div className="text-center p-3">
                            <div
                              className="spinner-border text-primary"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          </div>
                        ) : searchResults.length > 0 ? (
                          searchResults.map((result) => (
                            <div
                              key={result.id}
                              className="d-flex align-items-center border-bottom search-hover py-2 px-3"
                              onClick={() => {
                                setSearchOpen(false);
                                setSearchQuery("");
                                navigate(`/music/${result._id}`);
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              <div className="flex-shrink-0">
                                <img
                                  src={
                                    result.coverImageUrl ||
                                    `${process.env.PUBLIC_URL}/assets/images/avatars/01.png`
                                  }
                                  className="align-self-center img-fluid avatar-50 rounded-pill"
                                  alt={result.title}
                                />
                              </div>
                              <div className="d-flex flex-column ms-3 w-100">
                                <span className="h5">{result.title}</span>
                                <span className="text-muted small">
                                  @{result.artist}
                                </span>
                              </div>
                            </div>
                          ))
                        ) : searchQuery.length >= 2 ? (
                          <div className="text-center p-3">
                            <p className="mb-0">
                              No results found for "{searchQuery}"
                            </p>
                          </div>
                        ) : searchQuery.length > 0 ? (
                          <div className="text-center p-3">
                            <p className="mb-0">Type at least 2 characters</p>
                          </div>
                        ) : (
                          <div className="text-center p-3">
                            <p className="mb-0">Start typing to search</p>
                          </div>
                        )}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            )}

            {/* Hide install app for Artist */}
            {/* {!isArtist && (
              <ul className=" list-unstyled install-app">
                <li className="nav-item">
                  <a
                    className="nav-link d-flex align-items-end"
                    aria-current="page"
                    href="#"
                  >
                    <span className="material-icons">play_for_work</span>
                    <span className="item-name">Install App</span>
                  </a>
                </li>
              </ul>
            )} */}

            <ul className="mb-2 navbar-nav ms-auto align-items-center navbar-list mb-lg-0">
              {/* Hide mobile search for Artist */}
              {activeUserType === "User" && (
                <li
                  className="nav-item dropdown d-xl-none d-block p-2"
                  ref={mobileSearchRef}
                >
                  <a
                    href="#"
                    className="nav-link"
                    id="search-drop"
                    onClick={toggleMobileSearch}
                  >
                    <svg
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        opacity="0.5"
                        x="17.0365"
                        y="15.1223"
                        width="8.15546"
                        height={2}
                        rx={1}
                        transform="rotate(45 17.0365 15.1223)"
                        fill="currentColor"
                      />
                      <path
                        d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z"
                        fill="currentColor"
                      />
                    </svg>
                  </a>
                  <ul
                    className={`p-0 sub-drop dropdown-menu dropdown-menu-end ${
                      mobileSearchOpen ? "show" : ""
                    }`}
                    aria-labelledby="search-drop"
                    style={{ right: "-13vw" }}
                  >
                    <li>
                      <div className="p-3 card-header justify-content-between border-bottom rounded-top">
                        <div className="header-title">
                          <div className="iq-search-bar device-search position-relative">
                            <form action="#" className="searchbox">
                              <input
                                ref={mobileSearchInputRef}
                                type="text"
                                className="text search-input form-control bg-soft-primary"
                                placeholder="Search here... (Type 2+ characters)"
                                value={searchQuery}
                                onChange={handleSearchInputChange}
                              />
                              <a className="d-lg-none d-flex" href="#">
                                <span className="material-symbols-outlined">
                                  search
                                </span>
                              </a>
                            </form>
                          </div>
                        </div>
                      </div>
                      <div className="p-0 card-body all-notification">
                        {isLoading ? (
                          <div className="text-center p-3">
                            <div
                              className="spinner-border text-primary"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          </div>
                        ) : searchResults.length > 0 ? (
                          searchResults.map((result) => (
                            <div
                              key={result.id}
                              className="d-flex align-items-center border-bottom search-hover py-2 px-3"
                              onClick={() => {
                                setMobileSearchOpen(false);
                                setSearchQuery("");
                                navigate(`/profile/${result.id}`);
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              <div className="flex-shrink-0">
                                <img
                                  src={
                                    result.image ||
                                    `${process.env.PUBLIC_URL}/assets/images/avatars/default-avatar.png`
                                  }
                                  className="align-self-center img-fluid avatar-50 rounded-pill"
                                  alt={result.name}
                                  onError={(e) => {
                                    e.target.src = `${process.env.PUBLIC_URL}/assets/images/avatars/default-avatar.png`;
                                  }}
                                />
                              </div>
                              <div className="d-flex flex-column ms-3 w-100">
                                <span className="h6">{result.name}</span>
                                <span className="text-muted small">
                                  @{result.username}
                                </span>
                              </div>
                            </div>
                          ))
                        ) : searchQuery.length >= 2 ? (
                          <div className="text-center p-3">
                            <p className="mb-0">
                              No results found for "{searchQuery}"
                            </p>
                          </div>
                        ) : searchQuery.length > 0 ? (
                          <div className="text-center p-3">
                            <p className="mb-0">Type at least 2 characters</p>
                          </div>
                        ) : (
                          <div className="text-center p-3">
                            <p className="mb-0">Start typing to search</p>
                          </div>
                        )}
                      </div>
                    </li>
                  </ul>
                </li>
              )}

              {/* Hide chat for Artist */}
              {activeUserType === "User" && (
                <li className="btn btn-outline-primary p-2">
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      toggleChat();
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <img
                      src={`${process.env.PUBLIC_URL}/img/discussion.png`}
                      alt="discussion"
                    />
                  </a>
                </li>
              )}

              <li className="ps-3">
                <Link to="/settings">
                  <span className="material-icons">settings</span>
                </Link>
              </li>

              {/* Chat sidebar is rendered below (outside navbar-collapse) */}

              {/* Rest of the code remains the same for notifications and profile */}
              <li className="nav-item dropdown p-2" ref={notificationRef}>
                {/* <a
                  className={`nav-link p-0 ps-3 ${
                    notificationOpen ? "show" : ""
                  }`}
                  id="notification-drop"
                  onClick={handleNotificationToggle}
                  aria-expanded={notificationOpen ? "true" : "false"}
                  style={{ cursor: "pointer" }}
                >
                  <span className="material-icons">notifications</span>
                  {notifications.filter((n) => !n.isRead).length > 0 && (
                    <span className="bg-danger dots" />
                  )}
                </a> */}
                <a
                  className={`nav-link p-0 ps-3 ${notificationOpen ? "show" : ""}`}
                  id="notification-drop"
                  onClick={handleNotificationToggle}
                  aria-expanded={notificationOpen ? "true" : "false"}
                  style={{ cursor: "pointer", position: "relative" }}
                >
                  <span className="material-icons">notifications</span>

                  {/* ✅ NEW: Red dot for recent notifications (last 5 minutes) */}
                  {showNotificationDot && (
                    <span
                      className="bg-danger dots"
                      style={{
                        position: "absolute",
                        top: "2px",
                        right: "10px",
                        width: "8px",
                        height: "8px",
                        borderRadius: "50%",
                        border: "1px solid white",
                      }}
                    />
                  )}
                </a>
                <ul
                  className={`p-0 sub-drop dropdown-menu dropdown-menu-end ${
                    notificationOpen ? "show" : ""
                  }`}
                  aria-labelledby="notification-drop"
                  data-bs-popper={notificationOpen ? "static" : null}
                >
                  <li>
                    <div className="p-3 card-header d-flex justify-content-between bg-primary rounded-top">
                      <div className="header-title">
                        <h5 className="mb-0 text-white">All Notifications</h5>
                      </div>
                    </div>
                    <div
                      className="p-0 card-body all-notification"
                      style={{ maxHeight: "300px", overflowY: "auto" }}
                    >
                      {notifications.length > 0 ? (
                        notifications.map((notification) => (
                          <div
                            className={`iq-sub-card ${
                              notification.isRead ? "" : "bg-soft-primary"
                            }`}
                            key={notification._id}
                            onClick={() =>
                              handleNotificationClick(notification)
                            }
                            style={{ cursor: "pointer" }}
                          >
                            <div className="d-flex align-items-center">
                              <img
                                className="p-1 avatar-40 rounded-pill bg-soft-primary"
                                src={
                                  notification.image ||
                                  `${process.env.PUBLIC_URL}/assets/images/dashboard/24.png`
                                }
                                alt=""
                                loading="lazy"
                                onError={(e) => {
                                  e.target.src = `${process.env.PUBLIC_URL}/assets/images/avatars/default-avatar.png`;
                                }}
                              />
                              <div className="ms-3 w-100">
                                <h6 className="mb-0">
                                  {notification.title || notification.name}
                                </h6>
                                <div className="d-flex justify-content-between align-items-center">
                                  <small className="float-end font-size-12">
                                    {formatDistanceToNow(
                                      new Date(
                                        notification.createdAt ||
                                          notification.time,
                                      ),
                                      { addSuffix: true },
                                    )}
                                  </small>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="text-center p-3">
                          <p className="mb-0">No notifications</p>
                        </div>
                      )}
                    </div>
                  </li>
                </ul>
              </li>
              <li className="nav-item dropdownpy-2 pr-4" ref={profileRef}>
                <a
                  className={`p-0 ps-3 nav-link d-flex align-items-center position-relative ${
                    profileOpen ? "show" : ""
                  }`}
                  href="#"
                  id="profile-setting"
                  role="button"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleProfile();
                  }}
                  aria-expanded={profileOpen ? "true" : "false"}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src={userProfilePic}
                    alt="User-Profile"
                    className="theme-color-default-img img-fluid avatar avatar-40 avatar-rounded"
                    loading="lazy"
                  />
                  <div className="iq-profile-badge bg-success" />
                </a>
                <ul
                  className={`dropdown-menu dropdown-menu-end ${
                    profileOpen ? "show" : ""
                  }`}
                  aria-labelledby="profile-setting"
                  data-bs-popper="static"
                >
                  {activeUserType === "User" ? (
                    <>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/profile"
                          onClick={() => setProfileOpen(false)}
                        >
                          <span className="material-icons">account_circle</span>
                          Profile
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/account-setting"
                          onClick={() => setProfileOpen(false)}
                        >
                          <span className="material-icons">
                            manage_accounts
                          </span>
                          Account Setting
                        </Link>
                      </li>
                      {isArtist && (
                        <li>
                          <button
                            className="dropdown-item"
                            onClick={handleMoveToArtistAccount}
                          >
                            <span className="material-icons">
                              manage_accounts
                            </span>
                            Move to Artist Account
                          </button>
                        </li>
                      )}

                      <li>
                        <Link
                          className="dropdown-item"
                          to="/upgrade_plan"
                          onClick={() => setProfileOpen(false)}
                        >
                          <span className="material-icons">
                            workspace_premium
                          </span>
                          Upgrade Account
                        </Link>
                      </li>
                      <li>
                        <hr className="dropdown-divider" />
                      </li>
                    </>
                  ) : (
                    <>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/artist/profile"
                          onClick={() => setProfileOpen(false)}
                        >
                          <span className="material-icons">account_circle</span>
                          Profile
                        </Link>
                      </li>
                      <li>
                        <button
                          className="dropdown-item"
                          onClick={handleMoveToUserAccount}
                        >
                          <span className="material-icons">
                            manage_accounts
                          </span>
                          Move to User Account
                        </button>
                      </li>
                      <li>
                        <hr className="dropdown-divider" />
                      </li>
                    </>
                  )}

                  {/* ---------------------------------- */}
                  {/* <li>
                    <Link
                      className="dropdown-item"
                      to="/profile"
                      onClick={() => setProfileOpen(false)}
                    >
                      <span className="material-icons">account_circle</span>
                      Profile
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      to="/account-setting"
                      onClick={() => setProfileOpen(false)}
                    >
                      <span className="material-icons">manage_accounts</span>
                      Account Setting
                    </Link>
                  </li>
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={handleMoveToArtistAccount}
                    >
                      <span className="material-icons">manage_accounts</span>
                      Move to Artist Account
                    </button>
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      to="/upgrade_plan"
                      onClick={() => setProfileOpen(false)}
                    >
                      <span className="material-icons">workspace_premium</span>
                      Upgrade Account
                    </Link>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      to="/artist/profile"
                      onClick={() => setProfileOpen(false)}
                    >
                      <span className="material-icons">account_circle</span>
                      Profile
                    </Link>
                  </li>
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={handleMoveToUserAccount}
                    >
                      <span className="material-icons">manage_accounts</span>
                      Move to User Account
                    </button>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li> */}
                  {/* ----------- */}
                  <li>
                    <a
                      className="dropdown-item"
                      href="#"
                      onClick={() => setShowLogoutModal(true)}
                    >
                      <span className="material-icons">logout</span>
                      Logout
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* Chat Sidebar (outside navbar-collapse so it stays visible when header closes) */}
      {activeUserType === "User" &&
        (activeSubscription?.includes("chat_with_friends") ? (
          <div
            ref={chatRef}
            className={`sidebar1 ${chatOpen ? "" : "is-hidden"} p-2`}
            style={{
              position: "fixed",
              top: 0,
              right: 0,
              height: "100vh",
              width: "300px",
              backgroundColor: "white",
              zIndex: 1000,
              boxShadow: "-2px 0 5px rgba(0,0,0,0.1)",
              transition: "transform 0.3s ease-in-out",
              transform: chatOpen ? "translateX(0)" : "translateX(100%)",
            }}
          >
            <div className="sidebar-friends d-flex justify-content-between align-items-center p-3 border-bottom">
              <h2 className="card-title text-capitalize mb-0">Friends Online</h2>
              <div className="d-flex align-items-center">
                <small className="text-muted me-2">
                  {Object.keys(onlineFriends).length} online
                </small>
                <span className="btn btn-outline-primary" onClick={toggleChat}>
                  <i className="fa-solid fa-xmark" />
                </span>
              </div>
            </div>

            <div
              className="profile-list-pdiv suggestion p-3"
              style={{ maxHeight: "calc(100vh - 80px)", overflowY: "auto" }}
            >
              <div className="profile-list">
                {Object.keys(onlineFriends).length > 0 ? (
                  Object.entries(onlineFriends).map(([id, friend]) => (
                    <div
                      className="profile-box d-flex align-items-center justify-content-between p-2 border-bottom"
                      key={id}
                      onClick={() => handleFriendClick(friend, id)}
                    >
                      <div
                        className="profile-box-left d-flex align-items-center open"
                        style={{ cursor: "pointer" }}
                      >
                        <div style={{ position: "relative" }}>
                          <img
                            src={
                              friend.profilePic ||
                              `${process.env.PUBLIC_URL}/assets/images/avatars/01.png`
                            }
                            alt={friend.name}
                            className="rounded-circle me-2"
                            style={{
                              width: "40px",
                              height: "40px",
                              objectFit: "cover",
                            }}
                          />
                          <span
                            style={{
                              position: "absolute",
                              bottom: 0,
                              right: 0,
                              width: "12px",
                              height: "12px",
                              backgroundColor: "green",
                              borderRadius: "50%",
                              border: "2px solid white",
                              animation: "pulse 1.5s infinite",
                            }}
                          />
                        </div>

                        <div className="friend-wrap ms-2">
                          <p className="frnd-disp mb-0">{friend.name}</p>
                          <small className="text-success">Online</small>
                        </div>
                      </div>

                      <div className="profile-box-right">
                        <button className="common-form-button friend">
                          <img
                            src={`${process.env.PUBLIC_URL}/assets/images/chat.png`}
                            alt="Chat"
                          />
                        </button>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-center py-4">
                    <p className="text-muted">No friends online</p>
                    <small className="text-muted">
                      Ask your friends to login to see them here
                    </small>
                  </div>
                )}
              </div>
            </div>

            <style>
              {`
                @keyframes pulse {
                  0% { transform: scale(0.8); opacity: 0.7; }
                  50% { transform: scale(1.2); opacity: 1; }
                  100% { transform: scale(0.8); opacity: 0.7; }
                }
              `}
            </style>
          </div>
        ) : (
          <div
            ref={chatRef}
            className={`sidebar1 ${chatOpen ? "" : "is-hidden"} p-2`}
            style={{
              position: "fixed",
              top: 0,
              right: 0,
              height: "100vh",
              width: "300px",
              backgroundColor: "white",
              zIndex: 1000,
              boxShadow: "-2px 0 5px rgba(0,0,0,0.1)",
              transition: "transform 0.3s ease-in-out",
              transform: chatOpen ? "translateX(0)" : "translateX(100%)",
            }}
          >
            <div
              className="profile-list-pdiv suggestion p-3"
              style={{ maxHeight: "calc(100vh - 80px)", overflowY: "auto" }}
            >
              <div className="profile-list">
                <div className="text-center py-4">
                  <p className="text-muted">No Chats!</p>
                  <small className="text-muted">
                    Upgrade your account to chat with friends
                  </small>
                </div>
              </div>
            </div>
          </div>
        ))}
      {showLogoutModal && (
        <div className="modal-overlay">
          <div
            className="modal-content zoom-anim-dialog modal modal--form eventss color"
            style={{ maxWidth: "400px" }}
          >
            <button
              className="modal__close"
              onClick={() => setShowLogoutModal(false)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
              >
                <path d="M13.41,12l4.3-4.29a1,1,0,1,0-1.42-1.42L12,10.59,7.71,6.29A1,1,0,0,0,6.29,7.71L10.59,12l-4.3,4.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L12,13.41l4.29,4.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z" />
              </svg>
            </button>

            <h3 className="sign__title border-bottom pb-3">Confirm Logout</h3>

            <div className="sign__group sign__group--row">
              <div className="col-lg-12">
                <div className="form-group text-center">
                  <p className="mb-4">Are you sure you want to logout?</p>
                </div>
              </div>

              <div className="col-lg-12">
                <div className="d-flex gap-3">
                  <button
                    type="button"
                    className="release__buy flex-fill"
                    style={{ background: "#6c757d", border: "none" }}
                    onClick={() => setShowLogoutModal(false)}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="release__buy flex-fill"
                    style={{ background: "#dc3545", border: "none" }}
                    onClick={() => {
                      setShowLogoutModal(false);
                      handleLogout();
                    }}
                  >
                    Logout
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <style jsx>{`
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.7);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
          padding: 20px;
        }
      `}</style>
    </div>
  );
}

export default Header;
